import React from 'react'

import styles from './index.module.scss'

import type { MusicPlayStatus } from '../../constants'

import LazyImage from '@/components/LazyImage'
import { fallbackImg } from '@/constants/assets'
import { useInWhichPage } from '@/hooks/useInWhichPage'

export interface CoverProps {
  src?: string
  /** default: 48 */
  size?: number
  className?: string
  imageClassName?: string
  /** 指定不同的状态会渲染不同的图标，外部可通过类名 group/music 控制 idle 状态 hover 时渲染 */
  playStatus?: MusicPlayStatus
}

const Cover: React.FC<CoverProps> = (props) => {
  const { src, size = 68, className, imageClassName, playStatus } = props
  const { toggleShowDetail } = useGlobalAudioPlayer()
  const { inDetailPage } = useInWhichPage()
  return (
    <div
      className={cls`border-f-border-secondary relative border [&>img]:object-cover ${className} music-item-cover`}
    >
      <LazyImage
        width={size}
        height={size}
        alt='cover'
        className={cls`${!inDetailPage ? 'cursor-pointer' : ''} ${imageClassName}`}
        onClick={!inDetailPage ? () => toggleShowDetail(true) : undefined}
        src={src || fallbackImg}
        fallbackSrc={fallbackImg}
        style={{
          width: size,
          height: size,
        }}
      />
      {playStatus && (
        <CssIcon
          containerClassName={cls`
            absolute inset-0 flex items-center justify-center
            ${playStatus !== 'playing' ? 'duration-200 ease-in-out group-hover/music:bg-black/55' : 'bg-black/55'}
          `}
          className={cls`
            size-5 transition-opacity duration-200 ease-in-out
                       group-hover/music:opacity-100     ${playStatus === 'playing' ? `${styles.jumpMusic} group-hover/music:i-cus--tad-pause opacity-100` : 'group-hover/music:i-cus--tad-play'}
          `}
        />
      )}
    </div>
  )
}

export default Cover
